<template>
  <div v-show="legalAccepted" class="shadow rounded-lg">
    <div class="p-6">
      <div class="text-xl">Hallo {{user.given_name}} - Sie sind fast startklar.</div>
      <div class="text-sm text-gray-700">Folgen Sie diesen Anleitungen und legen Sie los.</div>
    </div>

    <div class="bg-gray-100 p-6 border-t">
      <div class="flex w-full justify-between">
        <div class="flex">
          <div class="mr-4">
            <font-awesome-icon icon="chevron-down" class="text-gray-700"></font-awesome-icon>
          </div>
          <div>
            <div>AGBs akzeptieren</div>
            <div class="text-sm">
              Um den Verkauf starten zu können müssen Sie die
              <a href="#" class="underline">AGBs</a> akzeptieren.
            </div>
          </div>
        </div>

        <div class="self-center">
          <button
            @click="acceptLegal"
            class="block relative text-center py-2 px-6 rounded-lg no-underline bg-green-500 text-white"
          >AGBs akzeptieren</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import accountClient from "@/api/central/account";

export default {
  data() {
    return {
      legalAccepted: false
    };
  },

  computed: {
    user() {
      return this.$store.state.authentication.keycloak.idTokenParsed;
    }
  },

  mounted() {
    accountClient
      .show()
      .then(({ data }) => (this.legalAccepted = !data.data.legal_accepted_at));
  },

  methods: {
    acceptLegal() {
      accountClient
        .acceptLegal()
        .then(
          ({ data }) => (this.legalAccepted = !data.data.legal_accepted_at)
        );
    }
  }
};
</script>